/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshInvoice} from '../api'

export const useMutationRefreshInvoice = createReactQueryMutationHook('refreshInvoice', refreshInvoice)
